export const states = [
  {
    isoCode: 'AC',
    name: 'Acre',
  },
  {
    isoCode: 'AL',
    name: 'Alagoas',
  },
  {
    isoCode: 'AM',
    name: 'Amazonas',
  },
  {
    isoCode: 'AP',
    name: 'Amapá',
  },
  {
    isoCode: 'BA',
    name: 'Bahia',
  },
  {
    isoCode: 'CE',
    name: 'Ceará',
  },
  {
    isoCode: 'DF',
    name: 'Distrito Federal',
  },
  {
    isoCode: 'ES',
    name: 'Espírito Santo',
  },
  {
    isoCode: 'GO',
    name: 'Goiás',
  },
  {
    isoCode: 'MA',
    name: 'Maranhão',
  },
  {
    isoCode: 'MG',
    name: 'Minas Gerais',
  },
  {
    isoCode: 'MS',
    name: 'Mato Grosso do Sul',
  },
  {
    isoCode: 'MT',
    name: 'Mato Grosso',
  },
  {
    isoCode: 'PA',
    name: 'Pará',
  },
  {
    isoCode: 'PB',
    name: 'Paraíba',
  },
  {
    isoCode: 'PE',
    name: 'Pernambuco',
  },
  {
    isoCode: 'PI',
    name: 'Piauí',
  },
  {
    isoCode: 'PR',
    name: 'Paraná',
  },
  {
    isoCode: 'RJ',
    name: 'Rio de Janeiro',
  },
  {
    isoCode: 'RN',
    name: 'Rio Grande do Norte',
  },
  {
    isoCode: 'RO',
    name: 'Rondônia',
  },
  {
    isoCode: 'RR',
    name: 'Roraima',
  },
  {
    isoCode: 'RS',
    name: 'Rio Grande do Sul',
  },
  {
    isoCode: 'SC',
    name: 'Santa Catarina',
  },
  {
    isoCode: 'SE',
    name: 'Sergipe',
  },
  {
    isoCode: 'SP',
    name: 'São Paulo',
  },
  {
    isoCode: 'TO',
    name: 'Tocantins',
  },
];
